import { render, staticRenderFns } from "./ColoriFrontali.vue?vue&type=template&id=533079ea"
import script from "./ColoriFrontali.vue?vue&type=script&lang=ts"
export * from "./ColoriFrontali.vue?vue&type=script&lang=ts"
import style0 from "./ColoriFrontali.vue?vue&type=style&index=0&id=533079ea&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533079ea')) {
      api.createRecord('533079ea', component.options)
    } else {
      api.reload('533079ea', component.options)
    }
    module.hot.accept("./ColoriFrontali.vue?vue&type=template&id=533079ea", function () {
      api.rerender('533079ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ColoriFrontali.vue"
export default component.exports